import React from "react";
import Navbar from "./components/navbar";
import CreateCellSiteComponent from "./create/create.component";
import CreateCellSiteProvider from "./create/provider/createMiCelu.provider";
import CreateUsedCellSiteProvider from "./create/used/provider/createUsedMiCelu.provider";
import CreateNewsCellSiteProvider from "./create/news/provider/createNewsMiCelu.provider";
import LogoAcinco from "../../assets/images/logo_acinco_white.png";

const CellSitePage = () => {
  return (
    <CreateCellSiteProvider>
      <CreateNewsCellSiteProvider>
        <CreateUsedCellSiteProvider>
          <div className="flex h-screen flex-col overflow-auto bg-gradient-to-b from-white to-[#121212]">
            <Navbar />
            <section className="z-10 flex h-full w-full items-center justify-center p-0">
              <div className="container mb-auto mt-auto w-full px-4 lg:px-20">
                <CreateCellSiteComponent />
              </div>
            </section>
            <div className="absolute bottom-0 mx-auto mb-4 flex w-full items-center justify-center text-white">
              Respaldado por{"   "}
              <img
                src={LogoAcinco}
                alt="logo_acinco"
                className="ml-2 max-h-14"
              />
            </div>
          </div>
        </CreateUsedCellSiteProvider>
      </CreateNewsCellSiteProvider>
    </CreateCellSiteProvider>
  );
};

export default CellSitePage;
